import HistorySurveyAccordion from "./HistorySurveyAccordion";

export default HistorySurveyAccordion;
